
import {loader} from '../js/loader'
import $ from 'zepto'
import HotArea from '../views/hotArea.vue'
import Scroller from 'vux/src/components/scroller/index.vue'

import Avatar from 'vue-avatar'
import configInfo from '../configInfo.js'
import advertisement from "./advertisement.vue"
import {wxShareConfig} from '../js/common/utils'

export default {
data () {
return {
regionName: '',
regionCode: '',
showHotArea: false,
showLeagueShoot: false,
showLeaguePoints: true,
indexContentHeight: 0,
latestMatchs: [],
latestLeagues: [],
curLeague: {},
curLeagueIndex: 0,
loading: true,
bestTeamNameLength: 10,
scrollMinWidth: 0
}
},
created:function(){
this.regionCode = this.$route.query.regionCode;
this.regionName = this.$route.query.regionName;
configInfo.orgCode = this.regionCode;
configInfo.orgName = this.regionName;
},
mounted(){

this.$nextTick(() => {
var height = document.body.clientHeight;
if (configInfo.isAdvertisementShow) {
this.indexContentHeight = height-55;
} else {
this.indexContentHeight = height-55;
}
});
this.initData();
},
methods: {
initWxShareConfig:function(){
var fullPath = window.location.href;
var shareImg = window.location.origin + configInfo.routerBase + "static/logo.png";
wxShareConfig({
title: '智能赛事',
desc: this.regionName+'校园足球赛事最新赛况赛果&赛事大数据',
link: fullPath,
imgUrl: shareImg,
type: 'link',
dataUrl: ''
}, () => {

}, () => {

});
},
initData: function () {
this.loading = true;
this.$vux.loading.show();
this.hagkHttp(this.hagkApi.getIndex(this.regionCode), {})
.then((res) => {
this.showLeagueShoot = false;
this.showLeaguePoints = true;
this.latestMatchs = [];
this.latestLeagues = [];
this.curLeague = {};
if (res.status == true) {
var result = res.result;
this.latestMatchs = result.latestMatchs;
this.latestLeagues = result.latestLeagues;
if(this.latestLeagues.length > 0) {
this.curLeague = this.latestLeagues[0];
this.getLeagueDetail(this.curLeague.id);
}

this.$nextTick(() => {
var width = document.body.clientWidth;
if(width < 360) {
this.bestTeamNameLength = 10;
} else {
this.bestTeamNameLength = 15;
}

if(1 == this.latestMatchs.length) {
this.scrollMinWidth = 600;
} else if(2 == this.latestMatchs.length) {
this.scrollMinWidth = 900;
} else {
this.scrollMinWidth = 1200;
}
});
this.initWxShareConfig();
}
this.loading = false;
this.$vux.loading.hide()
}, (error) => {
console.log(error)
this.$vux.loading.hide()
});
},
getLeagueDetail: function (leagueId) {
this.hagkHttp(this.hagkApi.getIndexLeague(leagueId), {})
.then((res) => {
if (res.status == true) {
this.curLeague.scoreBoard = res.result.scoreBoard;
this.curLeague.shooterBoard = res.result.shooterBoard;
this.curLeague.groups = res.result.groups;
this.curLeague.statistic = res.result.statistic;
this.getBest();
this.initShooterBoard();
}
}, (error) => {
console.log(error)
});
},
changeLeague: function (type) {
this.showLeagueShoot = false;
this.showLeaguePoints = true;

if('pre' == type) {
this.curLeagueIndex -= 1;
}
if('next' == type) {
this.curLeagueIndex += 1;
}
if(this.curLeagueIndex < 0) {
this.curLeagueIndex = this.latestLeagues.length - 1;
}
if(this.curLeagueIndex == this.latestLeagues.length) {
this.curLeagueIndex = 0;
}
this.curLeague = this.latestLeagues[this.curLeagueIndex];
this.getLeagueDetail(this.curLeague.id);
},
initShooterBoard: function () {
if (this.curLeague.shooterBoard) {
var shooterBoard = this.curLeague.shooterBoard;
for (var i = 0; i < shooterBoard.length; i++) {
shooterBoard[i].avatarUrl = this.getShooterAvatarUrl(shooterBoard[i].avatarId)
shooterBoard[i].useDefault = true;
}
this.curLeague.shooterBoard = shooterBoard;
}
},
getShooterAvatarUrl: function(avatarId) {
return this.hagkApi.getImgAsset(avatarId).url+'.jpg';
},
getBest: function () {
var scoreBoard = [];
if(this.curLeague.scoreBoard) {
scoreBoard = this.curLeague.scoreBoard;
}
var bestGoalFor;
var bestGoalAgainst;
var maxAvgGoal = 0;
var minAvgLoss = 9999;
for(var i = 0; i < scoreBoard.length; i++) {
if(0 == scoreBoard[i].matchNum) {
continue;
}

var tempAvgGoal = (scoreBoard[i].goal/scoreBoard[i].matchNum).toFixed(2);
if(tempAvgGoal > maxAvgGoal) {
maxAvgGoal = tempAvgGoal;
bestGoalFor = scoreBoard[i];
}

var tempAvgLoss = (scoreBoard[i].loss/scoreBoard[i].matchNum).toFixed(2);
if(tempAvgLoss < minAvgLoss) {
minAvgLoss = tempAvgLoss;
bestGoalAgainst = scoreBoard[i];
}
}
if(maxAvgGoal > 0) {
this.curLeague.bestGoalFor = bestGoalFor;
}
if(minAvgLoss < 9999) {
this.curLeague.bestGoalAgainst = bestGoalAgainst;
}
},
changeRegion: function (regionCode, regionName) {
this.hagkHttp(this.hagkApi.getHotAreaLeagueCount(regionCode), {}).then(
(res) => {
if(res.status){
var leagueCount = res.result;
if(leagueCount > 0){
this.showHotArea = false;
if(this.regionCode != regionCode) {
this.regionCode = regionCode;
this.regionName =regionName;
this.initData();
}
}else{
this.$router.push({path:'public_index',query:{regionName:regionName,regionCode:regionCode}});
}
}else{
console.log("获取联赛数量异常")
}
},
(err) => {console.log(err)}
)

},
switchTab: function(tag) {
if (tag) {
return
}
this.showLeagueShoot = !this.showLeagueShoot
this.showLeaguePoints = !this.showLeaguePoints
},
toLeagueList: function () {
this.$router.push({
path: '/league_list',
query: {
orgCode: this.regionCode,
orgName: this.regionName
}
});
},
toMatchDetail: function (matchId, homeTeamId, visitTeamId) {
this.$router.push({
path: '/match_info',
query: {
matchId: matchId,
homeTeamId: homeTeamId,
visitTeamId: visitTeamId
}
});
},
toLeagueDetail: function (leagueId, tabName) {
this.$router.push({
path: '/league_ongoing/'+tabName,
query: {
leagueId: leagueId
}
});
},
toMatchList: function () {
this.$router.push({
path: '/match_list',
query: {
regionCode: this.regionCode,
}
});
},
getRoundName: function (roundType, roundNum, roundTitle) {
var roundName = "--";

if(roundType=='cup_1'){
roundName = "决赛"
}
else if(roundType=='cup_2'){
roundName = "半决赛"
}
else if(roundType=='cup_4'){
roundName = "1/4决赛"
}
else if(roundType=='cup_8'){
roundName = "1/8决赛"
}
else if(roundType=='cup_16'){
roundName = "1/16决赛"
}
else if(roundType=='cup_32'){
roundName = "1/32决赛"
}
else if(roundType=='cup_64'){
roundName = "1/64决赛"
}
else if(roundType=='cup_128'){
roundName = "1/128决赛"
}
else if(roundType=='cup_team'||roundType=='league'){
roundName = "第"+roundNum+"轮"
}
else if(roundType== 'customized_rank_round'){
roundName = roundTitle
} else {
var arr = roundType.split("_")
roundName = +arr[3]+"-"+arr[2]+"名排位赛"
}
return roundName;
},
getMatchCardClass: function (leagueNameLength, homeTeamNameLength, vistingTeamNameLength) {
if(leagueNameLength <= 22 && homeTeamNameLength <= 18 && vistingTeamNameLength <= 18) {
return "mb20";
} else {
return "mb10";
}
},
advClose: function () {
var height = document.body.clientHeight;
this.indexContentHeight = height-55;
}
},
components: {
Scroller,
Avatar,
HotArea,
advertisement
},
filters: {
subfilter:function(value,sublength){
if (!value) return ''
value = value.toString()
if(value.length > sublength){
return value.substr(0,sublength)+"...";
}
return value;
}
}
}



// WEBPACK FOOTER //
// ./src/views/index_region.vue